import { agreementStatusLabels } from './agreements.constants';

/** Numeric API codes 0–5; aligns with `AgreementStatus` in `libs/isb-shared` (draft … inactive). */
const AGREEMENT_STATUS_CODES = [0, 1, 2, 3, 4, 5] as const;

/**
 * Options for the agreements status multiselect (`filter-statuses`). Values are numeric strings for the API.
 */
export const AGREEMENTS_STATUS_MULTISELECT_OPTIONS: readonly { value: string; label: string }[] =
    AGREEMENT_STATUS_CODES.map((code) => ({
        value: String(code),
        label: agreementStatusLabels[code],
    }));
